<template>
  <div class="addOccupy">
    <el-form ref="form" :model="form" :rules="rules" label-width="96px" label-position="left">
      <el-form-item label="占座数量" prop="occupySeat">
        <el-input disabled v-model="form.occupySeat" maxlength="15" placeholder="请输入占座数量"
                  v-input-filter="{ min: 1, max: 99, precision: 0 }"/>
      </el-form-item>

      <el-form-item label="恢复占座" prop="cancelOccupySeat">
        <el-input v-model="form.cancelOccupySeat" maxlength="15" placeholder="请输入恢复占座数量"
                  v-input-filter="{ min: 1, max: form.occupySeat, precision: 0 }">
        </el-input>
      </el-form-item>

<!--      <el-form-item label-width="0px">-->
<!--        <div class="util-remark">-->
<!--          说明：<br/>-->
<!--          1.未设置占座时间将不会自动恢复座位<br/>-->
<!--          2.在占座期间将减少可售票数量<br/>-->
<!--          3.占座倒计时结束后自动恢复座位<br/>-->
<!--        </div>-->
<!--      </el-form-item>-->

      <el-form-item label-width="0">
        <div class="main-form-btn">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="actionFn" :loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "addOccupy",
  props: {
    loadData: {
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        occupySeat: "",
        cancelOccupySeat: ""
      },
      rules: {
        cancelOccupySeat: [
          {required: true, message: "请输入占座数量", trigger: "blur"},
        ],
      },
      loading: false
    }
  },
  created() {
    this.form.occupySeat = this.loadData.occupySeat
    this.form.cancelOccupySeat = this.loadData.occupySeat
  },
  methods: {
    async actionFn() {
      const valid = await this.$refs.form.validate().catch(err => err);
      if (typeof valid === 'boolean' && valid) {
        this.loading = true
        let url = '/api/v1/manage/line/scheduling/cancel/occupy/seat'
        let {code} = await this.$axios.post(url, {
          ...this.form,
          schedulingId: this.loadData.schedulingId,
        })
        this.loading = false
        if (code === 1) {
          this.$message.success('操作成功')
          this.form = {
            occupySeat: "",
            cancelOccupySeat: ""
          }
          this.$emit("handClose")
        }
      }
    }

  }
}
</script>

<style scoped>

</style>